<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <p class=".title ma-2">Add a unit to {{hspl.huis_code }} </p>
    <v-form ref="addHspl" v-model="addHsplValid">
     <v-row no-gutters>
      <v-col class="ma-2">
       <v-text-field v-model="hspl.plan_code" :rules="plan_codeRules" label="Unit ID"></v-text-field>
      </v-col>
     </v-row>  
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addHspl" :disabled="!addHsplValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

// import {bus} from "../../../main";

export default {
  data() { 
    return {
      dialog: false,
      addHsplValid: false,
      huis_encrid: null,
      plan_code: '',
      hspl: {},
      plan_codeRules: [
          v => (v && v.length >= 3) || "A Unit ID is requird"
      ]
    }
  },
  methods: {
    open(huis_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hspl/getHuisToAddHspl.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuisToAddHspl"
          },
          getHuisToAddHspl: {
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hspl = res.data.getHuisToAddHspl;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addHspl() { 
      this.$axios
        .post("ares/json/ares/huis/hspl/addHspl.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addHspl"
          },
          addHspl: {
            huis_encrid: this.hspl.huis_encrid,
            plan_code: this.hspl.plan_code
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             //this.$router.reload('/huis/onHuis/' + res.data.addHspl.huis_encrid);            
            //  bus.$emit("closeDialog", "reload");
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addHspl.text,
              color: res.data.addHspl.color
            }); 
            this.$emit('updateData');
            this.dialog = false;
          }
        })
    },
  }
}
</script>

